import { render, staticRenderFns } from "./DashboardRight.vue?vue&type=template&id=211dabb4"
import script from "./DashboardRight.vue?vue&type=script&lang=js"
export * from "./DashboardRight.vue?vue&type=script&lang=js"
import style0 from "./DashboardRight.vue?vue&type=style&index=0&id=211dabb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports